import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import CylinderModule from "highcharts/modules/cylinder";
import ExportingModule from "highcharts/modules/exporting";

/**
 * Instância do Highcharts usada pelo gerador.
 *
 * Este é o ÚNICO lugar do gerador que importa "highcharts" e aplica
 * módulos. Todos os módulos abaixo já estavam em node_modules e nunca
 * haviam sido importados — nenhuma dependência nova foi instalada.
 *
 * Não importar "highcharts/highstock" aqui: aquele é um bundle separado,
 * com estado global próprio, usado por components/stockchart/StockChart.js
 * (que aplica o tema brand-dark). Misturar os dois traria aquele tema para
 * cá.
 *
 * A ordem importa: cylinder depende do highcharts-3d.
 */
const aplicar = (modulo) => {
  if (typeof modulo === "function") modulo(Highcharts);
};

aplicar(Highcharts3D);
aplicar(CylinderModule);
aplicar(ExportingModule);

Highcharts.setOptions({
  lang: {
    decimalPoint: ",",
    thousandsSep: ".",
    // Sem isto o Highcharts abrevia milhares como "4.9k" nos eixos.
    numericSymbols: null,
  },
});

export default Highcharts;
